import { render, staticRenderFns } from "./DAbstractPreview.vue?vue&type=template&id=0fc2c486&"
import script from "./DAbstractPreview.vue?vue&type=script&lang=js&"
export * from "./DAbstractPreview.vue?vue&type=script&lang=js&"
import style0 from "./DAbstractPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports